import React from "react";
import bg_image from "../../assets/images/Contact page Header.jpg";
import bg_image_m from "../../assets/images/contact Page Header Mobile screen-02.jpg";

const ContactBanner = () => {
  return (
   <div className=" w-full xl:bg-fixed relative mx-auto overflow-hidden flex items-center justify-center">
      {/* Content */}
      <div className="w-full">
        <img src={bg_image} alt="" className="w-full  h-auto hidden xl:block " />
        <img src={bg_image_m} alt="" className="w-full  h-auto  block xl:hidden" />
      </div>
    </div>
  );
};
export default ContactBanner;
